<app-qualifications [availableQualifications]="availableQualifications" [pageGroup]="pageGroup"
    firstLabel="Välj skolform">
    <h2>Ansökan om behörighet i yrkesämnen</h2>
    <p>Här ansöker du om behörighet att undervisa i yrkesämnen. Om du inte vill ansöka om ett yrkesämne kan du klicka på
        knappen ”nästa” för att hoppa över det här momentet.</p>
    <p>Du kan ansöka om behörighet att undervisa i ett yrkesämne om:</p>
    <ul>
        <li>Yrkesämnet ingår i din behörighetsgivande examen (gäller både dig som har en yrkeslärarexamen och dig som
            har en äldre lärarexamen avsedd för undervisning i ett ämne som idag är ett yrkesämne)</li>
        <li>Du har kunskaper du fått genom yrkeserfarenhet (inte genom läraryrket)</li>
        <li>Lång undervisningserfarenhet i ett eller flera yrkesämnen</li>
        <li>Blivit behörighetsförklarad av Skolöverstyrelsen</li>
    </ul>
    <p>
        Gör på följande sätt:
    </p>
    <ul style="list-style: decimal;">
        <li>Välj skolform</li>
        <li>Välj yrkesämne</li>
        <li>Välj sedan en eller flera grunder som du ansöker behörigheten</li>
        <li>Klicka sedan lägg till</li>
    </ul>
    <p>
        Du kan ansöka om flera yrkesämnen men du behöver välja och lägga till vart och ett.
    </p>
</app-qualifications>
